import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'gax-help-icon',
  template: ` <mat-icon>help</mat-icon> `,
  styleUrls: ['./help-icon.component.scss'],
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GaHelpIconComponent {}
